import { AddressEndpoints } from "@ADDRESS";
import { useGET } from "@API2";
import { Select } from "antd";
import { useEffect, useState } from "react";
const { Option } = Select;

const Warehouse = (props) => {
  const { data, loading } = useGET(`${AddressEndpoints.warehouses}`, true);
  const [val, setVal] = useState(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    let value = null;
    if (props.value?.warehouseId) {
      value = props.value.warehouseId;
    } else if (props.value?.warehouseName) {
      value = null;
    } else {
      value = null;
    }
    if (data.length === 1 || (data.length > 0 && props?.limitedWarehouses)) {
      if (!mounted && !props.notDefaultSelected) {
        //value = data[0]?.warehouseId;

        props.onChange({
          warehouseId: data[0]?.warehouseId,
          warehouseName: data[0]?.warehouseName,
          address: data[0]?.address,
        });
        if (props.setDefaultSelectedWarehouse) {
          props.setDefaultSelectedWarehouse(data[0]?.warehouseId);
        }
      }

      setMounted(true);
    }
    setVal(value);
  }, [props, loading, data, mounted]);

  if (loading) {
    return (
      <Select
        style={props.style}
        disabled
        loading
        placeholder="Yükleniyor..."
      />
    );
  }

  // excel ile yüklenmiş gönderinin il idsi olmadığı için sadece name seçiliymiş gibi gösteriyoruz.
  if (props.value?.id === 0 && props.value?.name) {
    return (
      <Select
        style={props.style}
        value={props.value.name}
        onClick={() => props.onChange({ id: null, name: null })}
      />
    );
  }

  return (
    <Select
      style={props.style}
      onChange={(v) => {
        if (v) {
          const that = data.find((x) => x.warehouseId === v);
          props.onChange({
            warehouseId: that.warehouseId,
            warehouseName: that.warehouseName,
            address: that.address,
          });
        } else {
          props.onChange({
            warehouseId: null,
            warehouseName: null,
            address: null,
          });
        }
        if (props.onSelect) {
          props.onSelect(v);
        }
      }}
      loading={loading}
      showSearch
      disabled={props.disabled || false}
      value={val}
      optionFilterProp="children"
      filterOption={(input, option) => (option?.name ?? "").includes(input)}
      placeholder={props.placeholder}
      allowClear={props.notDefaultSelected ? true : false}
    >
      {data?.length > 0 &&
        data.map((item) => (
          <Option
            key={item.warehouseId}
            value={item.warehouseId}
            name={item.address.addressLine1.toLocaleLowerCase("tr")}
          >
            {item.address.addressLine1}
          </Option>
        ))}
    </Select>
  );
};

export default Warehouse;
